export default __webpack_public_path__ + "static/media/blueDownload.dfab9838.svg";